import { createSelector } from '@reduxjs/toolkit'
import Utils from '../../common/Utils'


const getUserId = state => state.user.user.id
const getFriends = state => state.user.friends
const getGameId = state => state.game.gameState._id
const getPlayers = state => state.game.gameState.users
const getGameType = state => state.game.gameState.game_type
const getGamePlayerList = createSelector(
  [getGameId, getUserId, getFriends, getPlayers, getGameType], 
  (gameId, userId, friends, players, gameType) => {
    let playerList = []
    if (gameId && userId && players.length && Object.keys(friends).length) { // this is dumb and shouldn't need to be done
      let colors = []
      // TODO: this is temporary
      //  in the future use GameRegister
      if (gameType === 'DDDNaughtsAndCrosses') {
        colors = ['#88cc88', '#8888cc']
      } else if (gameType === 'TragedyOfTheCommons') {
        colors = ['#a3bf8f', '#8f95bf', '#bf968f', '#8fb2bf']
      } else {
        colors = Utils.getPlayerColors(players.length, gameId, 0.25, 0.75) // hue and saturation should come from the game design
      }
      for (let i=0; i<players.length; i++) {
        // all players see the same colors for each player
        let player = {
          id: players[i],
          name: friends?.[ players[i] ]?.name,
          color: colors[i],
        }
        // each player sees them self at the top of the list
        if (player.id === userId) {
          playerList.unshift(player)
        } else {
          playerList.push(player)
        }
      }
    }
    return playerList
  }
)


const GameSelectors = Object.freeze({
  getGamePlayerList,
})

export default GameSelectors
